/**************************************************
 * Nombre:       RelojProcesando
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Typography} from "@mui/material";
import Countdown from "react-countdown";

const RelojActivo = ({fechaRendimientos}) => {

    const renderer = ({hours, minutes, seconds, completed}) => {

        return <span>{`${hours}h-${minutes}m-${seconds}s`}</span>;

    };

    return (
        <Typography sx={{
            fontSize: 12,
            color: '#054073',
            fontWeight: 400,
            textAlign: 'center',
            lineHeight: 1.1
        }}>Rendimientos en: <br/>
            <Countdown
                daysInHours={true}
                date={fechaRendimientos}
                renderer={renderer}
            />
        </Typography>
    )

}
export default RelojActivo